import { Icon } from 'Components/shared/Icon';
import styled from 'styled-components';

const InfoIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.primary} !important;
  margin-right: 10px;
`;

const NotificationNotice = styled.div`
  margin-top: 20px;

  display: flex;
  align-items: center;

  color: ${({ theme }) => theme.colors.text} !important;
  font-size: 13px;
  line-height: 18px;
  font-weight: normal;
`;

const NotificationNoticeHighlight = styled.span`
  color: ${({ theme }) => theme.colors.primary} !important;
  font-weight: 600;
`;

export const Styled = {
  InfoIcon,
  NotificationNotice,
  NotificationNoticeHighlight,
};
